import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Advertisement } from "@/types/advertisementTypes"

export const useRelevantAdvertisement = ({ enabled }: { enabled: boolean }) => {
  //✅
  return useGenericQuery<Advertisement>({
    keys: QUERY_KEYS.advertisements.releventAdvertisement(),
    apiEndpoint: ENDPOINTS.advertisements.releventAdvertisement(),
    enabled: Boolean(enabled),
  })
}
